import React from 'react';
import styles from './home/Home.module.css';
import knight from '../img/64.png';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import GlitchPiece from './GlitchPiece';
import GlitchImage from './GlitchImage';
import { useUserData } from './UserDataContext';
import { auth } from './Login/firebase-config';

const Nav = () => {
  const { currentUser } = useUserData();
  const navigate = useNavigate();
  // Anonymous guests should still be nudged toward a real account
  const isMember = currentUser && !currentUser.isAnonymous;

  const itemClass = ({ isActive }) =>
    isActive ? `${styles.navbarItem} ${styles.navActive}` : styles.navbarItem;

  const handleLogOut = async () => {
    try {
      await auth.signOut();
      navigate('/');
    } catch (e) {
      console.error('Error signing out:', e);
    }
  };

  return (
    <div className={styles.container}>
      <nav className={styles.navbar}>
        <Link to="/" className={styles.navbarlogo}>
          <GlitchImage src={knight} alt="Logo" intensity={0.9} />
        </Link>
        <NavLink to="/play" className={itemClass}>
          <span className={styles.navPiece}><GlitchPiece piece="&#9814;" size={32} intensity={1.1} /></span>
          <span className={styles.navLabel}>Play</span>
        </NavLink>
        <NavLink to="/analysis" className={itemClass}>
          <span className={styles.navPiece}><GlitchPiece piece="&#9813;" size={32} intensity={0.8} /></span>
          <span className={styles.navLabel}>Analysis</span>
        </NavLink>
        <NavLink to="/puzzles" className={itemClass}>
          <span className={styles.navPiece}><GlitchPiece piece="&#9816;" size={32} intensity={1} /></span>
          <span className={styles.navLabel}>Puzzles</span>
        </NavLink>
        {isMember ? (
          <>
            <NavLink to="/profile" className={itemClass}>
              <span className={styles.navPiece}><GlitchPiece piece={"♟︎"} size={32} intensity={0.85} /></span>
              <span className={styles.navLabel}>Profile</span>
            </NavLink>
            <button type="button" onClick={handleLogOut} className={styles.navbarItem} style={{ background: 'none' }}>
              <span className={styles.navPiece}><GlitchPiece piece="&#9812;" size={32} intensity={0.7} /></span>
              <span className={styles.navLabel}>Log out</span>
            </button>
          </>
        ) : (
          <>
            <NavLink to="/login" className={itemClass}>
              <span className={styles.navPiece}><GlitchPiece piece="&#9812;" size={32} intensity={0.7} /></span>
              <span className={styles.navLabel}>Log in</span>
            </NavLink>
            <NavLink to="/signup" className={itemClass}>
              <span className={styles.navPiece}><GlitchPiece piece="&#9815;" size={32} intensity={0.9} /></span>
              <span className={styles.navLabel}>Sign up</span>
            </NavLink>
          </>
        )}
      </nav>
    </div>
  );
};

export default Nav;
